// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1HiTv","productName":"Table_productName__3RBMO"};